export default "__VITE_ASSET__Cu_Bl$AQ__"